
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MarketInquiryReceipt',
  props: {
    success: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
  },
})
